import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

// Menu "Video panjang" (2026-10-25): satu pintu untuk tiga jenis video panjang. Hanya mengarahkan ke halaman
// yang sudah ada — Kompilasi = halaman UGC (tidak diubah), Video musik & Narasi = halaman Video Lirik
// (SM Studio sebagai alat render). SM belum punya Video narasi — kartunya tidak ditampilkan., Upload video jadi = halaman UGC.
const JENIS = [
  {
    key: 'musik', icon: 'ti-player-play', judul: 'Video panjang',
    isi: 'Satu video utuh, atau satu video musik dari 1 lagu. Lirik boleh diisi, boleh juga tanpa lirik.',
    tag: ['Video musik', 'Upload video jadi'],
    aksi: [['musik', 'Buat video musik'], ['upload', 'Upload video jadi']],
  },
  {
    key: 'kompilasi', icon: 'ti-playlist', judul: 'Kompilasi (playlist)',
    isi: 'Banyak lagu disusun jadi satu video playlist dengan latar dan chapter.',
    tag: ['Banyak lagu', 'Diproses di server'],
    aksi: [['kompilasi', 'Buat kompilasi']],
  },
];

// Tombol/kartu mengikuti fitur rinci klien (2026-10-25): kartu tanpa tombol aktif disembunyikan.
const KUNCI_AKSI = { musik: 'video_musik', upload: 'ugc_upload', narasi: 'narasi', kompilasi: 'ugc_kompilasi' };

// "Proyek terakhir" (2026-10-27): semua jenis video panjang dalam satu daftar (routes/video-panjang.js).
const API = process.env.REACT_APP_API_URL;
const LABEL_JENIS = { kompilasi: 'Kompilasi', video_jadi: 'Video jadi', video_musik: 'Video musik', narasi: 'Narasi' };
const WARNA_TAHAP = {
  proses: [colors.accentText, colors.accentMuted], siap: [colors.warning, colors.warningMuted],
  terkirim: [colors.success, colors.successMuted], gagal: [colors.danger, colors.dangerMuted],
};
const umur = iso => { const j = (Date.now() - new Date(iso).getTime()) / 3600e3; return j < 1 ? 'baru saja' : j < 48 ? `${Math.round(j)} jam lalu` : `${Math.round(j / 24)} hari lalu`; };

function ProyekTerakhir({ onBuka }) {
  const [list, setList] = useState(null);
  useEffect(() => { axios.get(`${API}/api/video-panjang/terbaru`).then(r => setList(r.data || [])).catch(() => setList([])); }, []);
  if (!list || list.length === 0) return null;
  return (
    <div style={{ marginTop: 22 }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: colors.textPrimary, marginBottom: 2 }}>Proyek terakhir</div>
      <div style={{ fontSize: 12, color: colors.textSecondary, marginBottom: 10 }}>Semua jenis dalam satu daftar. Klik untuk membuka proyeknya.</div>
      <div style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, overflow: 'hidden' }}>
        {list.map((p, i) => {
          const w = WARNA_TAHAP[p.tahap] || WARNA_TAHAP.proses;
          return (
            <button key={`${p.sumber}-${p.id}`} type="button" onClick={() => onBuka(p)}
              style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', padding: '10px 14px', background: 'transparent', border: 'none',
                borderTop: i ? `1px solid ${colors.border}` : 'none', cursor: 'pointer', flexWrap: 'wrap', font: 'inherit' }}>
              <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                <div style={{ fontSize: 13.5, fontWeight: 600, color: colors.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.judul}</div>
                <div style={{ fontSize: 11.5, color: colors.textSecondary }}>{LABEL_JENIS[p.jenis] || p.jenis} · {umur(p.diubah)}</div>
              </div>
              <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', flex: '0 1 auto' }}>
                {p.bahasa.slice(0, 6).map(b => <span key={b} style={{ fontSize: 10.5, fontWeight: 700, padding: '2px 6px', borderRadius: 6, background: colors.bgCardMuted, color: colors.textSecondary }}>{b}</span>)}
                {p.bahasa.length > 6 && <span style={{ fontSize: 10.5, color: colors.textSecondary }}>+{p.bahasa.length - 6}</span>}
              </div>
              <span style={{ fontSize: 11.5, fontWeight: 700, padding: '3px 9px', borderRadius: 999, background: w[1], color: w[0], whiteSpace: 'nowrap' }}>{p.status}</span>
              <i className="ti ti-chevron-right" style={{ color: colors.textSecondary }} aria-hidden="true" />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function VideoPanjangHub({ onPilih, onBuka, fiturOn = () => true }) {
  const kartu = JENIS.map(j => ({ ...j, aksi: j.aksi.filter(([k]) => fiturOn(KUNCI_AKSI[k])) })).filter(j => j.aksi.length);
  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, margin: 0 }}>Video panjang</h1>
      <div style={{ fontSize: 13, color: colors.textSecondary, marginTop: 4, marginBottom: 16 }}>
        Pilih jenis video panjang yang mau kamu buat. Hasilnya masuk ke daftar video UGC, siap dipilihkan channel & jadwal.
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14 }}>
        {kartu.length === 0 && <div style={{ fontSize: 13, color: colors.textSecondary }}>Belum ada jenis video panjang yang aktif untuk akun ini. Hubungi admin untuk mengaktifkan fitur ini.</div>}
        {kartu.map(j => (
          <div key={j.key} style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 18, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <i className={`ti ${j.icon}`} style={{ fontSize: 28, color: colors.accent }} aria-hidden="true" />
            <div style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary }}>{j.judul}</div>
            <div style={{ fontSize: 13, color: colors.textSecondary, lineHeight: 1.5 }}>{j.isi}</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {j.tag.map(t => <span key={t} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 999, background: colors.bgCardMuted, color: colors.textSecondary }}>{t}</span>)}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 'auto', paddingTop: 4 }}>
              {j.aksi.map(([k, label], i) => (
                <button key={k} type="button" onClick={() => onPilih(k)} className={i === 0 ? 'btn btn-gold' : 'btn btn-outline'} style={{ fontSize: 13 }}>
                  {label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      {onBuka && <ProyekTerakhir onBuka={onBuka} />}
    </div>
  );
}

// Tautan kembali ke pilihan jenis, dipasang Dashboard di atas halaman UGC / Video Lirik (halamannya sendiri tidak diubah).
export function KembaliKeVideoPanjang({ onKembali }) {
  return (
    <button type="button" onClick={onKembali}
      style={{ background: 'transparent', border: 'none', padding: 0, marginBottom: 12, fontSize: 13, color: colors.textSecondary, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <i className="ti ti-arrow-left" aria-hidden="true" />Semua jenis video panjang
    </button>
  );
}
